import { render, staticRenderFns } from "./app-navigation.vue?vue&type=template&id=a3d5bc02&scoped=true&"
import script from "./app-navigation.vue?vue&type=script&lang=ts&"
export * from "./app-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./app-navigation.vue?vue&type=style&index=0&id=a3d5bc02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d5bc02",
  null
  
)

export default component.exports